<template>
  <Flex
    items-center
    gap-2
    class="px-5 hover:bg-gray-100 cursor-pointer p-1"
  >
    <Avatar space>
      <img
        src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/48b1ef6a-0508-4cf0-a3ab-c648ab79fbad/dfscc8s-20e70c61-5bb9-48f5-9107-e3d86ca8169f.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzQ4YjFlZjZhLTA1MDgtNGNmMC1hM2FiLWM2NDhhYjc5ZmJhZFwvZGZzY2M4cy0yMGU3MGM2MS01YmI5LTQ4ZjUtOTEwNy1lM2Q4NmNhODE2OWYucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.xqruWWXlHb5KTLDy25NChwLQb3jzljUsMYFjkAcCGF8"
      />
    </Avatar>
    <div>
      <div class="text-xs font-black">{{ props.name }}</div>
      <div class="text-2xs">{{ props.title }}</div>
    </div>
    <IconSolid icon="fa-chevron-down" xs />
  </Flex>
</template>

<script setup>
import IconSolid from '../atom/IconSolid.vue';

const props = defineProps({
  name: String,
  title: String
})
</script>

<style></style>
